/** Terms key-points gate copy for non-English locales. */

const mkPoint = (title, description) => ({ title, description });

const KEY_POINTS_HI = {
  notMedicalProvider: mkPoint(
    "चिकित्सा प्रदाता नहीं",
    "MyTara एक वेलनेस सूचना प्लेटफ़ॉर्म है। यह निदान, पर्चे या डॉक्टर का विकल्प नहीं है।"
  ),
  aiLimitations: mkPoint(
    "AI की सीमाएँ",
    "TARA के जवाब सूचनात्मक हैं। महत्वपूर्ण स्वास्थ्य जानकारी हमेशा योग्य विशेषज्ञ से सत्यापित करें।"
  ),
  notForEmergencies: mkPoint(
    "आपातकाल के लिए नहीं",
    "चिकित्सा आपातकाल में 112 पर कॉल करें या नज़दीकी अस्पताल जाएँ। इस ऐप पर भरोसा न करें।"
  ),
  dataProtected: mkPoint(
    "आपका डेटा सुरक्षित है",
    "हम भारत के DPDPA 2023 के तहत आपकी सहमति से स्वास्थ्य डेटा एकत्र करते हैं। आप कभी भी हटाने का अनुरोध कर सकते हैं।"
  ),
  userControl: mkPoint(
    "नियंत्रण आपके पास है",
    "आपका डेटा कभी नहीं बेचा जाता। गुमनाम, समेकित डेटा का उपयोग प्लेटफ़ॉर्म सुधारने के लिए हो सकता है।"
  ),
  termsMayUpdate: mkPoint(
    "नियम अपडेट हो सकते हैं",
    "बदलावों के बाद उपयोग जारी रखने का अर्थ है कि आप संशोधित नियम स्वीकार करते हैं। महत्वपूर्ण अपडेट की सूचना दी जाएगी।"
  ),
};

const KEY_POINTS_PA = {
  notMedicalProvider: mkPoint(
    "ਮੈਡੀਕਲ ਪ੍ਰਦਾਤਾ ਨਹੀਂ",
    "MyTara ਇੱਕ ਵੈਲਨੈਸ ਜਾਣਕਾਰੀ ਪਲੇਟਫਾਰਮ ਹੈ। ਇਹ ਨਿਦਾਨ, ਪਰਚਾ ਜਾਂ ਡਾਕਟਰ ਦੀ ਥਾਂ ਨਹੀਂ ਲੈ ਸਕਦਾ।"
  ),
  aiLimitations: mkPoint(
    "AI ਦੀਆਂ ਸੀਮਾਵਾਂ",
    "TARA ਦੇ ਜਵਾਬ ਜਾਣਕਾਰੀ ਲਈ ਹਨ। ਮਹੱਤਵਪੂਰਨ ਸਿਹਤ ਜਾਣਕਾਰੀ ਹਮੇਸ਼ਾ ਯੋਗ ਪੇਸ਼ੇਵਰ ਨਾਲ ਪੁਸ਼ਟੀ ਕਰੋ।"
  ),
  notForEmergencies: mkPoint(
    "ਐਮਰਜੈਂਸੀ ਲਈ ਨਹੀਂ",
    "ਮੈਡੀਕਲ ਐਮਰਜੈਂਸੀ ਵਿੱਚ 112 'ਤੇ ਕਾਲ ਕਰੋ ਜਾਂ ਨਜ਼ਦੀਕੀ ਹਸਪਤਾਲ ਜਾਓ। ਇਸ ਐਪ 'ਤੇ ਭਰੋਸਾ ਨਾ ਕਰੋ।"
  ),
  dataProtected: mkPoint(
    "ਤੁਹਾਡਾ ਡੇਟਾ ਸੁਰੱਖਿਅਤ ਹੈ",
    "ਅਸੀਂ ਭਾਰਤ ਦੇ DPDPA 2023 ਅਧੀਨ ਤੁਹਾਡੀ ਸਹਿਮਤੀ ਨਾਲ ਸਿਹਤ ਡੇਟਾ ਇਕੱਠਾ ਕਰਦੇ ਹਾਂ। ਤੁਸੀਂ ਕਿਸੇ ਵੀ ਸਮੇਂ ਮਿਟਾਉਣ ਦੀ ਬੇਨਤੀ ਕਰ ਸਕਦੇ ਹੋ।"
  ),
  userControl: mkPoint(
    "ਨਿਯੰਤਰਣ ਤੁਹਾਡੇ ਹੱਥ ਵਿੱਚ ਹੈ",
    "ਤੁਹਾਡਾ ਡੇਟਾ ਕਦੇ ਨਹੀਂ ਵੇਚਿਆ ਜਾਂਦਾ। ਗੁਮਨਾਮ, ਇਕੱਠੇ ਡੇਟਾ ਦਾ ਪਲੇਟਫਾਰਮ ਸੁਧਾਰ ਲਈ ਉਪਯੋਗ ਹੋ ਸਕਦਾ ਹੈ।"
  ),
  termsMayUpdate: mkPoint(
    "ਨਿਯਮ ਅਪਡੇਟ ਹੋ ਸਕਦੇ ਹਨ",
    "ਬਦਲਾਵਾਂ ਤੋਂ ਬਾਅਦ ਵਰਤੋਂ ਜਾਰੀ ਰੱਖਣ ਦਾ ਮਤਲਬ ਹੈ ਕਿ ਤੁਸੀਂ ਸੋਧੇ ਨਿਯਮ ਸਵੀਕਾਰ ਕਰਦੇ ਹੋ। ਅਸੀਂ ਮਹੱਤਵਪੂਰਨ ਅਪਡੇਟਾਂ ਦੀ ਸੂਚਨਾ ਦੇਵਾਂਗੇ।"
  ),
};

const KEY_POINTS_TE = {
  notMedicalProvider: mkPoint(
    "వైద్య సేవాదాత కాదు",
    "MyTara ఒక వెల్నెస్ సమాచార వేదిక. ఇది నిర్ధారణ, ప్రిస్క్రిప్షన్ లేదా డాక్టర్ స్థానం తీసుకోదు."
  ),
  aiLimitations: mkPoint(
    "AI పరిమితులు",
    "TARA సమాధానాలు సమాచారం కోసం మాత్రమే. ముఖ్యమైన ఆరోగ్య సమాచారాన్ని అ격్తుపరుస్తున్న నిపుణుడితో ధృవీకరించండి."
  ),
  notForEmergencies: mkPoint(
    "అత్యవసరాలకు కాదు",
    "వైద్య అత్యవసర సమయంలో 112 కి కాల్ చేయండి లేదా సమీప ఆసుపత్రికి వెళ్లండి. ఈ యాప్‌పై నమ్మకండి."
  ),
  dataProtected: mkPoint(
    "మీ డేటా రక్షించబడుతుంది",
    "భారతదేశ DPDPA 2023 కింద మీ సమ్మతితో ఆరోగ్య డేటాను సేకరిస్తాము. ఎప్పుడైనా తొలగింపు అభ్యర్థించవచ్చు."
  ),
  userControl: mkPoint(
    "నియంత్రణ మీ చేతిలో",
    "మీ డేటా ఎప్పుడూ అమ్మబడదు. అజ్ఞాత, సంకలిత డేటా వేదిక మెరుగుదలకు ఉపయోగించబడవచ్చు."
  ),
  termsMayUpdate: mkPoint(
    "నిబంధనలు అప్‌డేట్ అవ్వచ్చు",
    "మార్పుల తర్వాత ఉపయోగం కొనసాగించడం సవరించిన నిబంధనలను అంగీకరించినట్లే. ముఖ్యమైన అప్‌డేట్‌లకు తెలియజేస్తాము."
  ),
};

const KEY_POINTS_TA = {
  notMedicalProvider: mkPoint(
    "மருத்துவ வழங்குநர் அல்ல",
    "MyTara ஒரு நல்வாழ்வு தகவல் தளம். இது நோயறிதல், மருந்து பரிந்துரை அல்லது மருத்துவருக்கு மாற்றாகாது."
  ),
  aiLimitations: mkPoint(
    "AI வரம்புகள்",
    "TARA பதில்கள் தகவல் நோக்கத்திற்காக மட்டும். முக்கியமான சுகாதார தகவலை தகுதியான நிபுணரிடம் சரிபார்க்கவும்."
  ),
  notForEmergencies: mkPoint(
    "அவசரநிலைக்கு அல்ல",
    "மருத்துவ அவசரநிலையில் 112 அழைக்கவும் அல்லது அருகிலுள்ள மருத்துவமனைக்குச் செல்லவும். இந்த பயன்பாட்டை நம்ப வேண்டாம்."
  ),
  dataProtected: mkPoint(
    "உங்கள் தரவு பாதுகாக்கப்படுகிறது",
    "இந்தியாவின் DPDPA 2023 கீழ் உங்கள் ஒப்புதலுடன் சுகாதார தரவை சேகரிக்கிறோம். எப்போது வேண்டுமானாலும் நீக்கம் கோரலாம்."
  ),
  userControl: mkPoint(
    "கட்டுப்பாடு உங்கள் கையில்",
    "உங்கள் தரவு விற்கப்படாது. அடையாளம் காணப்படாத, ஒருங்கிணைக்கப்பட்ட தரவு தளத்தை மேம்படுத்த பயன்படுத்தப்படலாம்."
  ),
  termsMayUpdate: mkPoint(
    "விதிமுறைகள் புதுப்பிக்கப்படலாம்",
    "மாற்றங்களுக்குப் பிறகு தொடர்ந்து பயன்படுத்துவது திருத்தப்பட்ட விதிமுறைகளை ஏற்றுக்கொள்வதாகும். முக்கியமான புதுப்பிப்புகள் தெரிவிக்கப்படும்."
  ),
};

const KEY_POINTS_MR = {
  notMedicalProvider: mkPoint(
    "वैद्यकीय प्रदाता नाही",
    "MyTara हे एक वेलनेस माहिती व्यासपीठ आहे. ते निदान, प्रिस्क्रिप्शन किंवा डॉक्टरांची जागा घेत नाही."
  ),
  aiLimitations: mkPoint(
    "AI च्या मर्यादा",
    "TARA ची उत्तरे माहितीसाठी आहेत. महत्त्वाची आरोग्य माहिती नेहमी पात्र तज्ज्ञाकडून तपासा."
  ),
  notForEmergencies: mkPoint(
    "आपत्कालीन परिस्थितीसाठी नाही",
    "वैद्यकीय आपत्कालीन परिस्थितीत 112 वर कॉल करा किंवा जवळच्या रुग्णालयात जा. या अॅपवर अवलंबून राहू नका."
  ),
  dataProtected: mkPoint(
    "तुमचा डेटा सुरक्षित आहे",
    "आम्ही भारताच्या DPDPA 2023 अंतर्गत तुमच्या संमतीने आरोग्य डेटा गोळा करतो. तुम्ही कधीही हटवण्याची विनंती करू शकता."
  ),
  userControl: mkPoint(
    "नियंत्रण तुमच्याकडे",
    "तुमचा डेटा कधीही विकला जात नाही. अनामिक, एकत्रित डेटा व्यासपीठ सुधारण्यासाठी वापरला जाऊ शकतो."
  ),
  termsMayUpdate: mkPoint(
    "अटी अपडेट होऊ शकतात",
    "बदलांनंतर वापर सुरू ठेवणे म्हणजे तुम्ही सुधारित अटी स्वीकारता. महत्त्वाच्या अपडेट्सची सूचना दिली जाईल."
  ),
};

const KEY_POINTS_BN = {
  notMedicalProvider: mkPoint(
    "চিকিৎসা প্রদানকারী নয়",
    "MyTara একটি ওয়েলনেস তথ্য প্ল্যাটফর্ম। এটি রোগ নির্ণয়, প্রেসক্রিপশন বা ডাক্তারের বিকল্প নয়।"
  ),
  aiLimitations: mkPoint(
    "AI-এর সীমাবদ্ধতা",
    "TARA-এর উত্তর তথ্যমূলক। গুরুত্বপূর্ণ স্বাস্থ্য তথ্য সবসময় যোগ্য পেশাদারের সাথে যাচাই করুন।"
  ),
  notForEmergencies: mkPoint(
    "জরুরি অবস্থার জন্য নয়",
    "চিকিৎসা জরুরি অবস্থায় 112-এ কল করুন বা নিকটস্থ হাসপাতালে যান। এই অ্যাপের উপর নির্ভর করবেন না।"
  ),
  dataProtected: mkPoint(
    "আপনার ডেটা সুরক্ষিত",
    "আমরা ভারতের DPDPA 2023-এর অধীনে আপনার সম্মতিতে স্বাস্থ্য ডেটা সংগ্রহ করি। যেকোনো সময় মুছে ফেলার অনুরোধ করতে পারেন।"
  ),
  userControl: mkPoint(
    "নিয়ন্ত্রণ আপনার হাতে",
    "আপনার ডেটা কখনো বিক্রি হয় না। বেনামী, সমষ্টিগত ডেটা প্ল্যাটফর্ম উন্নতির জন্য ব্যবহার হতে পারে।"
  ),
  termsMayUpdate: mkPoint(
    "শর্তাবলী আপডেট হতে পারে",
    "পরিবর্তনের পর ব্যবহার চালিয়ে যাওয়া মানে আপনি সংশোধিত শর্তাবলী গ্রহণ করেছেন। গুরুত্বপূর্ণ আপডেট জানানো হবে।"
  ),
};

const KEY_POINTS_KN = {
  notMedicalProvider: mkPoint(
    "ವೈದ್ಯಕೀಯ ಒದಗಿಸುವವರಲ್ಲ",
    "MyTara ಒಂದು ವೆಲ್ನೆಸ್ ಮಾಹಿತಿ ವೇದಿಕೆ. ಇದು ರೋಗನಿರ್ಣಯ, ಔಷಧಿ ಅಥವಾ ವೈದ್ಯರ ಬದಲಿ ಅಲ್ಲ."
  ),
  aiLimitations: mkPoint(
    "AI ಪರಿಮಿತಿಗಳು",
    "TARA ಪ್ರತಿಕ್ರಿಯೆಗಳು ಮಾಹಿತಿಗಾಗಿ ಮಾತ್ರ. ಮುಖ್ಯ ಆರೋಗ್ಯ ಮಾಹಿತಿಯನ್ನು ಅರ್ಹ ವೃತ್ತಿಪರರೊಂದಿಗೆ ಪರಿಶೀಲಿಸಿ."
  ),
  notForEmergencies: mkPoint(
    "ತುರ್ತು ಪರಿಸ್ಥಿತಿಗಳಿಗೆ ಅಲ್ಲ",
    "ವೈದ್ಯಕೀಯ ತುರ್ತು ಪರಿಸ್ಥಿತಿಯಲ್ಲಿ 112 ಗೆ ಕರೆ ಮಾಡಿ ಅಥವಾ ಹತ್ತಿರದ ಆಸ್ಪತ್ರೆಗೆ ಹೋಗಿ. ಈ ಅಪ್ಲಿಕೇಶನ್‌ನ ಮೇಲೆ ಅವಲಂಬಿಸಬೇಡಿ."
  ),
  dataProtected: mkPoint(
    "ನಿಮ್ಮ ಡೇಟಾ ಸುರಕ್ಷಿತವಾಗಿದೆ",
    "ಭಾರತದ DPDPA 2023 ಅಡಿಯಲ್ಲಿ ನಿಮ್ಮ ಒಪ್ಪಿಗೆಯೊಂದಿಗೆ ಆರೋಗ್ಯ ಡೇಟಾವನ್ನು ಸಂಗ್ರಹಿಸುತ್ತೇವೆ. ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ಅಳಿಸಲು ವಿನಂತಿಸಬಹುದು."
  ),
  userControl: mkPoint(
    "ನಿಯಂತ್ರಣ ನಿಮ್ಮ ಕೈಯಲ್ಲಿ",
    "ನಿಮ್ಮ ಡೇಟಾ ಎಂದಿಗೂ ಮಾರಾಟವಾಗುವುದಿಲ್ಲ. ಅನಾಮಧೇಯ, ಒಟ್ಟುಗೂಡಿಸಿದ ಡೇಟಾವನ್ನು ವೇದಿಕೆ ಸುಧಾರಣೆಗೆ ಬಳಸಬಹುದು."
  ),
  termsMayUpdate: mkPoint(
    "ನಿಯಮಗಳು ನವೀಕರಿಸಬಹುದು",
    "ಬದಲಾವಣೆಗಳ ನಂತರ ಬಳಕೆ ಮುಂದುವರಿಸುವುದು ಸಂಶೋಧಿತ ನಿಯಮಗಳನ್ನು ಸ್ವೀಕರಿಸಿದಂತೆ. ಮುಖ್ಯ ನವೀಕರಣಗಳನ್ನು ತಿಳಿಸಲಾಗುತ್ತದೆ."
  ),
};

const mkTermsShell = (overrides) => ({
  beforeContinue: "Before you continue",
  agreeingTo: "Here's what you're agreeing to",
  keyPointsAria: "Key points summary",
  keyPointsTitle: "Key Points",
  readFullTerms: "Read the full Terms & Conditions",
  decline: "Decline",
  accept: "Accept",
  sections: "Sections",
  servicesTitle: "Terms of Services",
  summaryAria: "Terms and conditions summary",
  summaryTitle: "MyTara™ Terms and Conditions",
  readFullDocument: "Read full Terms & Conditions",
  registerConsent:
    "I have read the summarized Terms & Conditions and agree to register.",
  fullDocumentLink: "View full Terms & Conditions",
  fullDocumentHint: "Legal document · Read online",
  reachedBottom: "You have reached the end",
  scrollToBottom: "Scroll to bottom",
  nextSection: "Next section",
  translating: "Translating terms...",
  scrollKeyPointsRequired:
    "Please read all key points and scroll to the bottom before accepting.",
  acceptFailed: "Could not save your acceptance. Please try again.",
  documentTagline: "Please review each section carefully before accepting.",
  documentDetails: "Document details",
  documentVersion: "Version",
  documentPages: "pages",
  documentViewOnline: "View online only",
  documentNotice:
    "This document is for online viewing only. Downloading, printing, screen capture, and snipping-tool reproduction are restricted. Unauthorized copying may violate applicable law and your agreement with myTara.",
  ...overrides,
});

const TERMS_UI_HI = {
  sections: "अनुभाग",
  servicesTitle: "सेवा की शर्तें",
  summaryTitle: "MyTara™ नियम और शर्तें",
  readFullDocument: "पूरे नियम और शर्तें पढ़ें",
  registerConsent:
    "मैंने सारांशित नियम और शर्तें पढ़ ली हैं और पंजीकरण के लिए सहमत हूँ।",
  fullDocumentLink: "पूरे नियम और शर्तें देखें",
  fullDocumentHint: "कानूनी दस्तावेज़ · ऑनलाइन पढ़ें",
  reachedBottom: "आप अंत तक पहुँच गए हैं",
  scrollToBottom: "नीचे तक स्क्रॉल करें",
  nextSection: "अगला अनुभाग",
  translating: "नियमों का अनुवाद हो रहा है...",
  scrollKeyPointsRequired:
    "कृपया सभी मुख्य बिंदु पढ़ें और स्वीकार करने से पहले नीचे तक स्क्रॉल करें।",
  acceptFailed: "आपकी स्वीकृति सहेजी नहीं जा सकी। कृपया पुनः प्रयास करें।",
  documentTagline: "कृपया स्वीकार करने से पहले प्रत्येक अनुभाग ध्यान से पढ़ें।",
  documentDetails: "दस्तावेज़ विवरण",
  documentVersion: "संस्करण",
  documentPages: "पृष्ठ",
  documentViewOnline: "केवल ऑनलाइन देखें",
  documentNotice:
    "यह दस्तावेज़ केवल ऑनलाइन देखने के लिए है। डाउनलोड, प्रिंट, स्क्रीन कैप्चर और स्निपिंग टूल से प्रतिलिपि प्रतिबंधित है। अनधिकृत प्रतिलिपि कानून और myTara समझौते का उल्लंघन कर सकती है।",
};

const TERMS_UI_PA = {
  sections: "ਭਾਗ",
  servicesTitle: "ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ",
  summaryTitle: "MyTara™ ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ",
  readFullDocument: "ਪੂਰੇ ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ ਪੜ੍ਹੋ",
  registerConsent:
    "ਮੈਂ ਸਾਰਾਂਸ਼ਿਤ ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ ਪੜ੍ਹ ਲਈਆਂ ਹਨ ਅਤੇ ਰਜਿਸਟਰ ਕਰਨ ਲਈ ਸਹਿਮਤ ਹਾਂ।",
  fullDocumentLink: "ਪੂਰੇ ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ ਦੇਖੋ",
  fullDocumentHint: "ਕਾਨੂੰਨੀ ਦਸਤਾਵੇਜ਼ · ਔਨਲਾਈਨ ਪੜ੍ਹੋ",
  reachedBottom: "ਤੁਸੀਂ ਅੰਤ ਤੱਕ ਪਹੁੰਚ ਗਏ ਹੋ",
  scrollToBottom: "ਹੇਠਾਂ ਤੱਕ ਸਕ੍ਰੌਲ ਕਰੋ",
  nextSection: "ਅਗਲਾ ਭਾਗ",
  translating: "ਨਿਯਮਾਂ ਦਾ ਅਨੁਵਾਦ ਹੋ ਰਿਹਾ ਹੈ...",
  scrollKeyPointsRequired:
    "ਕਿਰਪਾ ਕਰਕੇ ਸਾਰੇ ਮੁੱਖ ਬਿੰਦੂ ਪੜ੍ਹੋ ਅਤੇ ਸਵੀਕਾਰ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਹੇਠਾਂ ਸਕ੍ਰੌਲ ਕਰੋ।",
  acceptFailed: "ਤੁਹਾਡੀ ਸਵੀਕ੍ਰਿਤੀ ਸੁਰੱਖਿਅਤ ਨਹੀਂ ਹੋ ਸਕੀ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  documentTagline: "ਕਿਰਪਾ ਕਰਕੇ ਸਵੀਕਾਰ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਹਰ ਭਾਗ ਧਿਆਨ ਨਾਲ ਪੜ੍ਹੋ।",
  documentDetails: "ਦਸਤਾਵੇਜ਼ ਵਿਵਰਣ",
  documentVersion: "ਵਰਜਨ",
  documentPages: "ਪੰਨੇ",
  documentViewOnline: "ਕੇਵਲ ਔਨਲਾਈਨ ਦੇਖੋ",
  documentNotice:
    "ਇਹ ਦਸਤਾਵੇਜ਼ ਕੇਵਲ ਔਨਲਾਈਨ ਦੇਖਣ ਲਈ ਹੈ। ਡਾਉਨਲੋਡ, ਪ੍ਰਿੰਟ, ਸਕ੍ਰੀਨ ਕੈਪਚਰ ਅਤੇ ਸਨਿਪਿੰਗ ਟੂਲ ਪ੍ਰਤਿਬੰਧਿਤ ਹਨ।",
};

const TERMS_UI_TE = {
  sections: "విభాగాలు",
  servicesTitle: "సేవా నిబంధనలు",
  summaryTitle: "MyTara™ నిబంధనలు మరియు షరతులు",
  readFullDocument: "పూర్తి నిబంధనలు మరియు షరతులు చదవండి",
  registerConsent:
    "నేను సారాంశ నిబంధనలు మరియు షరతులు చదివాను మరియు నమోదు చేయడానికి అంగీకరిస్తున్నాను.",
  fullDocumentLink: "పూర్తి నిబంధనలు మరియు షరతులు చూడండి",
  fullDocumentHint: "చట్టపరమైన పత్రం · ఆన్‌లైన్‌లో చదవండి",
  reachedBottom: "మీరు చివరికి చేరుకున్నారు",
  scrollToBottom: "క్రిందికి స్క్రోల్ చేయండి",
  nextSection: "తదుపరి విభాగం",
  translating: "నిబంధనలు అనువదించబడుతున్నాయి...",
  scrollKeyPointsRequired:
    "దయచేసి అన్ని ముఖ్య అంశాలు చదివి, అంగీకరించే ముందు క్రిందికి స్క్రోల్ చేయండి.",
  acceptFailed: "మీ అంగీకారం సేవ్ కాలేదు. దయచేసి మళ్లీ ప్రయత్నించండి.",
  documentTagline: "దయచేసి అంగీకరించే ముందు ప్రతి విభాగాన్ని జాగ్రత్తగా చదవండి.",
  documentDetails: "పత్రం వివరాలు",
  documentVersion: "వర్షన్",
  documentPages: "పేజీలు",
  documentViewOnline: "ఆన్‌లైన్‌లో మాత్రమే చూడండి",
  documentNotice:
    "ఈ పత్రం ఆన్‌లైన్ వీక్షణకు మాత్రమే. డౌన్‌లోడ్, ప్రింట్ మరియు స్క్రీన్ క్యాప్చర్ నిషేధించబడ్డాయి.",
};

const TERMS_UI_TA = {
  sections: "பிரிவுகள்",
  servicesTitle: "சேவை விதிமுறைகள்",
  summaryTitle: "MyTara™ விதிமுறைகள் மற்றும் நிபந்தனைகள்",
  readFullDocument: "முழு விதிமுறைகள் மற்றும் நிபந்தனைகளைப் படிக்கவும்",
  registerConsent:
    "சுருக்க விதிமுறைகளைப் படித்து பதிவு செய்ய ஒப்புக்கொள்கிறேன்.",
  fullDocumentLink: "முழு விதிமுறைகள் மற்றும் நிபந்தனைகளைக் காண்க",
  fullDocumentHint: "சட்ட ஆவணம் · ஆன்லைனில் படிக்கவும்",
  reachedBottom: "நீங்கள் முடிவை அடைந்துவிட்டீர்கள்",
  scrollToBottom: "கீழே ஸ்க்ரோல் செய்யவும்",
  nextSection: "அடுத்த பிரிவு",
  translating: "விதிமுறைகள் மொழிபெயர்க்கப்படுகின்றன...",
  scrollKeyPointsRequired:
    "அனைத்து முக்கிய புள்ளிகளையும் படித்து, ஏற்கும் முன் கீழே ஸ்க்ரோல் செய்யவும்.",
  acceptFailed: "உங்கள் ஏற்பு சேமிக்கப்படவில்லை. மீண்டும் முயற்சிக்கவும்.",
  documentTagline: "ஏற்கும் முன் ஒவ்வொரு பிரிவையும் கவனமாக படிக்கவும்.",
  documentDetails: "ஆவண விவரங்கள்",
  documentVersion: "பதிப்பு",
  documentPages: "பக்கங்கள்",
  documentViewOnline: "ஆன்லைனில் மட்டும் பார்க்கவும்",
  documentNotice:
    "இந்த ஆவணம் ஆன்லைன் பார்வைக்கு மட்டுமே. பதிவிறக்கம், அச்சிடுதல் மற்றும் திரைப்பிடிப்பு தடைசெய்யப்பட்டுள்ளது.",
};

const TERMS_UI_MR = {
  sections: "विभाग",
  servicesTitle: "सेवा अटी",
  summaryTitle: "MyTara™ अटी आणि शर्ती",
  readFullDocument: "संपूर्ण अटी आणि शर्ती वाचा",
  registerConsent:
    "मी सारांशित अटी वाचल्या आहेत आणि नोंदणीसाठी सहमत आहे.",
  fullDocumentLink: "संपूर्ण अटी आणि शर्ती पहा",
  fullDocumentHint: "कायदेशीर दस्तऐवज · ऑनलाइन वाचा",
  reachedBottom: "तुम्ही शेवटापर्यंत पोहोचला आहात",
  scrollToBottom: "खालपर्यंत स्क्रोल करा",
  nextSection: "पुढील विभाग",
  translating: "अटींचे भाषांतर होत आहे...",
  scrollKeyPointsRequired:
    "कृपया सर्व मुख्य मुद्दे वाचा आणि स्वीकारण्यापूर्वी खालपर्यंत स्क्रोल करा.",
  acceptFailed: "तुमची स्वीकृती जतन होऊ शकली नाही. पुन्हा प्रयत्न करा.",
  documentTagline: "कृपया स्वीकारण्यापूर्वी प्रत्येक विभाग काळजीपूर्वक वाचा.",
  documentDetails: "दस्तऐवज तपशील",
  documentVersion: "आवृत्ती",
  documentPages: "पृष्ठे",
  documentViewOnline: "फक्त ऑनलाइन पहा",
  documentNotice:
    "हा दस्तऐवज फक्त ऑनलाइन पाहण्यासाठी आहे. डाउनलोड, प्रिंट आणि स्क्रीन कॅप्चर प्रतिबंधित आहे.",
};

const TERMS_UI_BN = {
  sections: "বিভাগ",
  servicesTitle: "সেবার শর্তাবলী",
  summaryTitle: "MyTara™ শর্তাবলী",
  readFullDocument: "সম্পূর্ণ শর্তাবলী পড়ুন",
  registerConsent:
    "আমি সারাংশ শর্তাবলী পড়েছি এবং নিবন্ধনে সম্মত।",
  fullDocumentLink: "সম্পূর্ণ শর্তাবলী দেখুন",
  fullDocumentHint: "আইনি নথি · অনলাইনে পড়ুন",
  reachedBottom: "আপনি শেষে পৌঁছেছেন",
  scrollToBottom: "নিচে স্ক্রল করুন",
  nextSection: "পরবর্তী বিভাগ",
  translating: "শর্তাবলী অনুবাদ হচ্ছে...",
  scrollKeyPointsRequired:
    "অনুগ্রহ করে সব মূল বিষয় পড়ে গ্রহণের আগে নিচে স্ক্রল করুন।",
  acceptFailed: "আপনার গ্রহণযোগ্যতা সংরক্ষণ হয়নি। আবার চেষ্টা করুন।",
  documentTagline: "গ্রহণের আগে প্রতিটি বিভাগ সাবধানে পড়ুন।",
  documentDetails: "নথির বিবরণ",
  documentVersion: "সংস্করণ",
  documentPages: "পৃষ্ঠা",
  documentViewOnline: "শুধু অনলাইনে দেখুন",
  documentNotice:
    "এই নথি শুধু অনলাইনে দেখার জন্য। ডাউনলোড, প্রিন্ট ও স্ক্রিন ক্যাপচার নিষিদ্ধ।",
};

const TERMS_UI_KN = {
  sections: "ವಿಭಾಗಗಳು",
  servicesTitle: "ಸೇವಾ ನಿಯಮಗಳು",
  summaryTitle: "MyTara™ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
  readFullDocument: "ಪೂರ್ಣ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಓದಿ",
  registerConsent:
    "ನಾನು ಸಾರಾಂಶ ನಿಯಮಗಳನ್ನು ಓದಿದ್ದೇನೆ ಮತ್ತು ನೋಂದಣಿಗೆ ಒಪ್ಪುತ್ತೇನೆ.",
  fullDocumentLink: "ಪೂರ್ಣ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
  fullDocumentHint: "ಕಾನೂನು ದಾಖಲೆ · ಆನ್‌ಲೈನ್‌ನಲ್ಲಿ ಓದಿ",
  reachedBottom: "ನೀವು ಅಂತ್ಯಕ್ಕೆ ತಲುಪಿದ್ದೀರಿ",
  scrollToBottom: "ಕೆಳಗೆ ಸ್ಕ್ರೋಲ್ ಮಾಡಿ",
  nextSection: "ಮುಂದಿನ ವಿಭಾಗ",
  translating: "ನಿಯಮಗಳನ್ನು ಅನುವಾದಿಸಲಾಗುತ್ತಿದೆ...",
  scrollKeyPointsRequired:
    "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಮುಖ್ಯ ಅಂಶಗಳನ್ನು ಓದಿ ಮತ್ತು ಒಪ್ಪಿಕೊಳ್ಳುವ ಮೊದಲು ಕೆಳಗೆ ಸ್ಕ್ರೋಲ್ ಮಾಡಿ.",
  acceptFailed: "ನಿಮ್ಮ ಒಪ್ಪಿಗೆಯನ್ನು ಉಳಿಸಲಾಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  documentTagline: "ಒಪ್ಪಿಕೊಳ್ಳುವ ಮೊದಲು ಪ್ರತಿ ವಿಭಾಗವನ್ನು ಎಚ್ಚರಿಕೆಯಿಂದ ಓದಿ.",
  documentDetails: "ದಾಖಲೆ ವಿವರಗಳು",
  documentVersion: "ಆವೃತ್ತಿ",
  documentPages: "ಪುಟಗಳು",
  documentViewOnline: "ಆನ್‌ಲೈನ್‌ನಲ್ಲಿ ಮಾತ್ರ ವೀಕ್ಷಿಸಿ",
  documentNotice:
    "ಈ ದಾಖಲೆ ಆನ್‌ಲೈನ್ ವೀಕ್ಷಣೆಗೆ ಮಾತ್ರ. ಡೌನ್‌ಲೋಡ್, ಮುದ್ರಣ ಮತ್ತು ಸ್ಕ್ರೀನ್ ಕ್ಯಾಪ್ಚರ್ ನಿಷೇಧಿತ.",
};

export const TERMS_LOCALE_BLOCKS = {
  hi: mkTermsShell({
    ...TERMS_UI_HI,
    beforeContinue: "जारी रखने से पहले",
    agreeingTo: "आप जिन बातों से सहमत हो रहे हैं",
    keyPointsAria: "मुख्य बिंदुओं का सारांश",
    keyPointsTitle: "मुख्य बिंदु",
    readFullTerms: "पूरे नियम और शर्तें पढ़ें",
    decline: "अस्वीकार करें",
    accept: "स्वीकार करें",
    keyPoints: KEY_POINTS_HI,
  }),
  pa: mkTermsShell({
    ...TERMS_UI_PA,
    beforeContinue: "ਜਾਰੀ ਰੱਖਣ ਤੋਂ ਪਹਿਲਾਂ",
    agreeingTo: "ਤੁਸੀਂ ਜਿਨ੍ਹਾਂ ਗੱਲਾਂ ਨਾਲ ਸਹਿਮਤ ਹੋ ਰਹੇ ਹੋ",
    keyPointsAria: "ਮੁੱਖ ਬਿੰਦੂਆਂ ਦਾ ਸਾਰ",
    keyPointsTitle: "ਮੁੱਖ ਬਿੰਦੂ",
    readFullTerms: "ਪੂਰੇ ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ ਪੜ੍ਹੋ",
    decline: "ਅਸਵੀਕਾਰ ਕਰੋ",
    accept: "ਸਵੀਕਾਰ ਕਰੋ",
    keyPoints: KEY_POINTS_PA,
  }),
  te: mkTermsShell({
    ...TERMS_UI_TE,
    beforeContinue: "కొనసాగించే ముందు",
    agreeingTo: "మీరు ఏ విషయాలకు అంగీకరిస్తున్నారు",
    keyPointsAria: "ముఖ్య అంశాల సారాంశం",
    keyPointsTitle: "ముఖ్య అంశాలు",
    readFullTerms: "పూర్తి నిబంధనలు మరియు షరతులు చదవండి",
    decline: "తిరస్కరించు",
    accept: "అంగీకరించు",
    keyPoints: KEY_POINTS_TE,
  }),
  ta: mkTermsShell({
    ...TERMS_UI_TA,
    beforeContinue: "தொடர்வதற்கு முன்",
    agreeingTo: "நீங்கள் ஒப்புக்கொள்ளும் விஷயங்கள்",
    keyPointsAria: "முக்கிய புள்ளிகள் சுருக்கம்",
    keyPointsTitle: "முக்கிய புள்ளிகள்",
    readFullTerms: "முழு விதிமுறைகள் மற்றும் நிபந்தனைகளைப் படிக்கவும்",
    decline: "நிராகரி",
    accept: "ஏற்கவும்",
    keyPoints: KEY_POINTS_TA,
  }),
  mr: mkTermsShell({
    ...TERMS_UI_MR,
    beforeContinue: "पुढे जाण्यापूर्वी",
    agreeingTo: "तुम्ही ज्या गोष्टींना सहमती देत आहात",
    keyPointsAria: "मुख्य मुद्द्यांचा सारांश",
    keyPointsTitle: "मुख्य मुद्दे",
    readFullTerms: "संपूर्ण अटी आणि शर्ती वाचा",
    decline: "नकार द्या",
    accept: "स्वीकारा",
    keyPoints: KEY_POINTS_MR,
  }),
  bn: mkTermsShell({
    ...TERMS_UI_BN,
    beforeContinue: "চালিয়ে যাওয়ার আগে",
    agreeingTo: "আপনি যে বিষয়গুলোতে সম্মত হচ্ছেন",
    keyPointsAria: "মূল বিষয়ের সারাংশ",
    keyPointsTitle: "মূল বিষয়",
    readFullTerms: "সম্পূর্ণ শর্তাবলী পড়ুন",
    decline: "প্রত্যাখ্যান",
    accept: "গ্রহণ করুন",
    keyPoints: KEY_POINTS_BN,
  }),
  kn: mkTermsShell({
    ...TERMS_UI_KN,
    beforeContinue: "ಮುಂದುವರಿಸುವ ಮೊದಲು",
    agreeingTo: "ನೀವು ಒಪ್ಪುತ್ತಿರುವ ವಿಷಯಗಳು",
    keyPointsAria: "ಮುಖ್ಯ ಅಂಶಗಳ ಸಾರಾಂಶ",
    keyPointsTitle: "ಮುಖ್ಯ ಅಂಶಗಳು",
    readFullTerms: "ಪೂರ್ಣ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಓದಿ",
    decline: "ನಿರಾಕರಿಸಿ",
    accept: "ಒಪ್ಪಿಕೊಳ್ಳಿ",
    keyPoints: KEY_POINTS_KN,
  }),
};

export const EN_TERMS_KEY_POINTS = {
  notMedicalProvider: mkPoint(
    "Not a medical provider",
    "MyTara is a wellness information platform. It does not diagnose, prescribe, or replace a doctor."
  ),
  aiLimitations: mkPoint(
    "AI has limitations",
    "TARA's responses are informational. Always verify important health information with a qualified professional."
  ),
  notForEmergencies: mkPoint(
    "Not for emergencies",
    "In a medical emergency, call 112 or go to the nearest hospital. Do not rely on this app."
  ),
  dataProtected: mkPoint(
    "Your data is protected",
    "We collect health data with your consent under India's DPDPA 2023. You can request deletion at any time."
  ),
  userControl: mkPoint(
    "You're in control",
    "Your data is never sold. Anonymized, aggregated data may be used to improve the platform."
  ),
  termsMayUpdate: mkPoint(
    "Terms may update",
    "Continued use after changes means you accept revised terms. We'll notify you of significant updates."
  ),
};

export const applyTermsLocaleBlocks = (translations) => {
  Object.entries(TERMS_LOCALE_BLOCKS).forEach(([lang, terms]) => {
    if (!translations[lang]) return;
    translations[lang].terms = {
      ...translations[lang].terms,
      ...terms,
    };
  });
};
